import { capitalizeWord } from "app/shared/utils/helperFunctions";

type SignupMessages = {
    missingFirstName: string,
    invalidFirstName: string,
    missingLastName: string,
    invalidLastName: string,
    missingPhoneNumber: string,
    invalidPhoneNumber: string,
    missingBirthday: string,
    invalidBirthday: string,
    birthdayAgevalidation: (brandTitle: string) => string;
    missingZipCode: string,
    invalidZipCode: string,
    missingEmailAddress: string,
    invalidEmailAddress: string,
    missingPassword: string,
    invalidPassword: string,
    missingConfirmPassword: string,
    confirmPasswordMismatch: string,
    passwordMustContain: string,
    passwordMinLength: string,
    passwordMinNumbers: string,
    passwordUpperCase: string,
    forceLogoutMsg: string,
};

interface PasswordValidationMessages {
  minLength: string;
  hasNumber: string;
  hasUpperCase: string;
  hasSpecialCharacter: string;
  noSpace: string;
  validationHeader: string;
}

type EmptyMessages = Record<string, never>;

type ErrorMessages = {
    CART: EmptyMessages;
    REWARDS: EmptyMessages;
    LOGIN: EmptyMessages;
    RECENT_ORDERS: EmptyMessages;
    SIGNUP: SignupMessages;
    PASSWORD: PasswordValidationMessages;
  };

const ERROR_MESSAGES: ErrorMessages = {
    CART: {},
    REWARDS: {},
    LOGIN: {},
    RECENT_ORDERS: {},
    SIGNUP: {
        missingFirstName: "Please enter a first name",
        invalidFirstName: "Please enter a valid first name",
        missingLastName: "Please enter a last name",
        invalidLastName: "Please enter a valid last name",
        missingPhoneNumber: "Please enter a phone number",
        invalidPhoneNumber: "Please enter a valid phone number",
        missingBirthday: "Please enter a birthday",
        invalidBirthday: "Birthdate is invalid",
        birthdayAgevalidation: (brandTitle: string) => `Sorry, you need to be at least 13 to use ${capitalizeWord(brandTitle)} Rewards. See you in a couple years.`,
        missingZipCode: "Please enter a zip code",
        invalidZipCode: "Please enter a valid zip",
        missingEmailAddress: "Please enter a email",
        invalidEmailAddress: "Please enter a valid email",
        missingPassword: "Please enter a password",
        invalidPassword: "Invalid",
        missingConfirmPassword: "Please confirm your password",
        confirmPasswordMismatch: "Confirm password must match",
        passwordMustContain: "Password must contain:",
        passwordMinLength: "At least 8 characters",
        passwordMinNumbers: "At least one number",
        passwordUpperCase: "At least one uppercase letter",
        forceLogoutMsg: "You’ve been logged out for security reasons. Please sign in again.",
    },
    PASSWORD: {
      minLength: "Between 8 to 64 characters",
      hasNumber: "At least one number",
      hasUpperCase: "At least one uppercase letter",
      hasSpecialCharacter: "At least one special character: @#$!)&(-_",
      noSpace: "No spaces allowed",
      validationHeader: "Password must contain:",
    },
} as const;

/**
 * Decouples Messages with components.
 * Retrieves an error message based on the specified section and message key from `ERROR_MESSAGES`.
 * This function can be extended for future localization (e.g., i18n) to return localized messages.
 * @param section - The section within `ERROR_MESSAGES` (e.g., 'SIGNUP').
 * @param messageKey - The specific message key within the section (e.g., 'missingFirstName').
 * @returns The corresponding error message as a string.
 */
export function getErrorMessage<
  Section extends keyof typeof ERROR_MESSAGES,
  MessageKey extends keyof typeof ERROR_MESSAGES[Section],
>(section: Section, messageKey: MessageKey): string {
    /*Any logic for localization of literals in future can be done here*/
  return ERROR_MESSAGES[section][messageKey] as string;
}
export default ERROR_MESSAGES;
